import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import {
  ACTION_RESET_PASSWORD_ERROR,
  ACTION_RESET_PASSWORD_LOADED,
  ACTION_RESET_PASSWORD_LOADING,
  PATH_RESET_PASSWORD
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = (data) => {
  return Observable.of({
    type: ACTION_RESET_PASSWORD_ERROR,
    payload: data
  })
}

const resetPasswordEpic = action$ =>
  action$.ofType(ACTION_RESET_PASSWORD_LOADING)
    .mergeMap(action => {

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_RESET_PASSWORD}`,
        body: {emailAddress:action.payload},
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_RESET_PASSWORD_LOADED,
          payload: data
        }
      }).catch(errorHandler)
    })

export default resetPasswordEpic



// WEBPACK FOOTER //
// ./src/epics/ResetPasswordEpic.js